module.exports = ".bg-teal {\n  background-color: #55a88e !important; }\n"